import React from 'react';
import { Link } from 'react-router-dom';
import { BpMark } from '../BpLogo';
import { CHAIN } from '../../chain/config';

// /join — choose how you want to use BirrPlug.
export default function JoinUs() {
	return (
		<div className="bp-auth-page">
			<div className="bp-join-wrap">
				<div className="bp-auth-mark"><BpMark size={56} /></div>
				<h1>Join BirrPlug</h1>
				<p className="bp-auth-sub">Everything runs on your wallet — pick your side of the marketplace.</p>

				<div className="bp-join-grid">
					<Link to="/signup" className="bp-join-card">
						<span className="bp-join-icon">🛍️</span>
						<h3>I want to shop</h3>
						<p>Browse local shops, pay in BRC or cash on delivery, and track every order to your door.</p>
						<ul>
							<li>Instant wallet sign-up</li>
							<li>On-chain payment receipts</li>
							<li>Live shipment tracking</li>
						</ul>
						<span className="bp-btn-primary">Create Buyer Account</span>
					</Link>

					<Link to="/join/business" className="bp-join-card featured">
						<span className="bp-join-badge">For businesses</span>
						<span className="bp-join-icon">🏬</span>
						<h3>I want to sell</h3>
						<p>Open your shop, list products, and get paid in BRC straight to your wallet — no banks in between.</p>
						<ul>
							<li>Free Starter plan — 10 products</li>
							<li>Direct-to-wallet BRC payouts</li>
							<li>Orders, shipping & analytics dashboard</li>
						</ul>
						<span className="bp-btn-primary">Open Your Shop</span>
					</Link>
				</div>

				<p className="bp-auth-chain bp-dim">Powered by {CHAIN.name} · your keys, your store, your money</p>
			</div>
		</div>
	);
}
